export default {
    exportDataAsCsv( data, fileName ) {
        // Create a link on the DOM
        const linkElement = document.createElement( 'a' );

        // Encode the csvContent and set it as the href
        const href = window.URL.createObjectURL( new Blob( [ data ], { type: 'text/csv;charset=utf-8' } ) );
        linkElement.setAttribute( 'href', href );

        // Set the name of the file
        linkElement.setAttribute(
            'download',
            fileName.includes( '.csv' )
                ? fileName
                : `${ fileName }.csv`,
        );

        // Emulate a click to download the file
        linkElement.click();

        // Free up memory
        window.URL.revokeObjectURL( href );
    },
};
